import { render, staticRenderFns } from "./OptionField.vue?vue&type=template&id=17273e45"
import script from "./OptionField.vue?vue&type=script&lang=ts"
export * from "./OptionField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports